import { create } from "zustand";

import { ModalContentType } from "@/types";

import { useModalStore } from "./modal.store";

interface ThirdPartiesState {
  onSuccess?: () => void;
  onReject?: () => void;
}

interface ThirdPartiesActions {
  showConfirmModal: (properties: ThirdPartiesState) => void;
  closeConfirmModal: () => void;
}

export type ThirdPartiesStore = ThirdPartiesState & ThirdPartiesActions;

const initialDefaultState: ThirdPartiesState = {};

export const useThirdPartiesStore = create<ThirdPartiesStore>()((set, get) => ({
  ...initialDefaultState,
  showConfirmModal: ({ onSuccess, onReject }) => {
    const { setType, open } = useModalStore.getState();

    setType(ModalContentType.thirdParty);
    open();
    set({
      onSuccess: onSuccess || get().closeConfirmModal,
      onReject: onReject || get().closeConfirmModal,
    });
  },
  closeConfirmModal: () => {
    const { close } = useModalStore.getState();

    close();
    set({ onSuccess: undefined, onReject: undefined });
  },
}));
